import type { TypeSafeTableColumns } from "@dealer-center/core-components";
import { Alert, Table } from "@dealer-center/core-components";
import type { userSearchAPIInterface } from "@dealer-center/ddc-api-user-interface";
import styled from "styled-components";
import { AccountLink } from "@dealer-center/ddc-core-custom-components";

const StyledResultsArea = styled.div`
  align-items: center;
  justify-content: center;
`;

const StyledAlert = styled(Alert)`
  margin-bottom: 1rem;
`;

const StyledResultArea = styled.div`
  align-items: center;
  justify-content: center;
  #interstate-table {
    max-width: 1200px;
  }
`;

const StyledResultHeader = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

interface PagesUserSearchUiResultsProps {
  data?: userSearchAPIInterface;
  error: Error | null;
  loading: boolean;
}

export const PagesUserSearchUiResults = ({
  data,
  error,
  loading
}: PagesUserSearchUiResultsProps) => {
  if (error) {
    return (
      <StyledResultsArea>
        <StyledAlert role="alert" sx={{ marginBottom: "16px" }} type="error">
          {error.message && error.message.length > 2 ? error.message : "Error"}
        </StyledAlert>
      </StyledResultsArea>
    );
  }

  const columns: TypeSafeTableColumns<userSearchAPIInterface> = [
    {
      title: "Account ID",
      dataIndex: "id",
      render: (_text: string, record: userSearchAPIInterface) => (
        <AccountLink accountID={record.ownerId} component="client-search" />
      )
    },
    // {
    //   dataIndex: "platformId",
    //   title: "Platform ID"
    // },
    {
      dataIndex: "username",
      title: "Bridge ID"
    },
    {
      dataIndex: "registered",
      title: "Registered"
    },
    {
      dataIndex: "userId",
      title: "CC Username"
    },
    // {
    //   dataIndex: "id",
    //   title: "ID"
    // },
    {
      dataIndex: "parentId",
      title: "Parent ID"
    },
    {
      dataIndex: "firstName",
      title: "First Name"
    },
    {
      dataIndex: "lastName",
      title: "Last Name"
    },
    {
      dataIndex: "suffix",
      title: "Suffix"
    },
    {
      dataIndex: "email",
      title: "Email"
    },
    {
      dataIndex: "email2",
      title: "Email 2"
    },
    {
      dataIndex: "workPhone",
      title: "Work Phone"
    },
    {
      dataIndex: "homePhone",
      title: "Home Phone"
    },
    {
      dataIndex: "phone3",
      title: "Phone 3"
    },
    {
      dataIndex: "lastModified",
      title: "Last Modified",
      render: (text: string) => new Date(Number(text)).toLocaleString()
    }
    // {
    //   dataIndex: "ownerId",
    //   title: "Owner ID"
    // }
  ];

  return (
    <StyledResultsArea>
      <StyledResultArea>
        <StyledResultHeader>Result</StyledResultHeader>
        <Table.Table
          columns={columns}
          data={data ? [data] : []}
          dataDensity="small"
          enablePagination={false}
          isLoading={loading}
          tableLayout="auto"
        />
      </StyledResultArea>
    </StyledResultsArea>
  );
};
